<template>
  <div class="top-bar">
    <div class="button-group">
      <el-dropdown placement="bottom-start" @command="handleNewCommand">
        <el-button type="primary" icon="el-icon-plus">新建</el-button>
        <el-dropdown-menu class="button-new-drop" slot="dropdown">
          <el-dropdown-item command="folder">
            <img src="~@/assets/images/icon-new-folder.png" alt="" />
            文件夹
          </el-dropdown-item>
          <el-dropdown-item command="/console/editor" divided>
            <img src="~@/assets/images/icon-new-report1.png" alt="" />
            空白报告
          </el-dropdown-item>
          <el-dropdown-item command="/console/editor?template=1">
            <img src="~@/assets/images/icon-new-report2.png" alt="" />
            产业简报
          </el-dropdown-item>
          <el-dropdown-item command="/console/editor?template=2">
            <img src="~@/assets/images/icon-new-report3.png" alt="" />
            科技情报
          </el-dropdown-item>
          <el-dropdown-item command="/console/editor?template=3">
            <img src="~@/assets/images/icon-new-report4.png" alt="" />
            技术分析
          </el-dropdown-item>
          <el-dropdown-item command="/console/editor?template=7">
            <img src="~@/assets/images/icon-new-report5.png" alt="" />
            政策态势
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-upload
        style="display: inline-block"
        :action="uploadAction"
        :headers="uploadHeaders"
        :show-file-list="false"
        accept=".doc,.docx"
        :on-success="handleUploadSuccess"
        :on-error="handleUploadError"
        :before-upload="handleUploadBefore"
      >
        <el-button type="info" icon="el-icon-import">导入</el-button>
      </el-upload>
    </div>
    <div class="robot">
      <div class="inner-search">
        <el-input
          placeholder="搜索报告/文件夹"
          v-model="searchKey"
          @keyup.native.enter="handleSearch"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div>
      <div class="inner-lastest-search">
        最近搜索
        <el-tag
          effect="dark"
          type="info"
          v-for="(item, index) in searchHistory"
          :key="index"
          @click="handleHistorySearch(item)"
        >
          {{ item }}
        </el-tag>
      </div>
    </div>

    <el-dialog
      title="新建文件夹"
      :visible.sync="dialogFolderVisible"
      width="500px"
    >
      <div>
        <el-form
          ref="folderForm"
          label-width="80px"
          :model="folderForm"
          :rules="folderRules"
        >
          <el-form-item label="名称" prop="folderName">
            <el-input
              v-model="folderForm.folderName"
              placeholder="请输入名称"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div slot="footer" style="text-align: right" v-loading="folderLoading">
        <el-button @click="dialogFolderVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleAddFolder">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { axiosOptions, axiosRequest } from "../../util/request";
import { Loading } from "element-ui";

export default {
  data() {
    return {
      dialogFolderVisible: false,
      folderForm: {
        folderName: "",
      },
      folderRules: {
        folderName: [
          { required: true, message: "请输入名称", trigger: "blur" },
        ],
      },
      folderLoading: false,
      searchKey: "",
      searchHistory: [],

      uploadAction: `${process.env.VUE_APP_BASE_API}/user-report/import`,
      uploadHeaders: {
        authorization: "Bearer " + localStorage.getItem("token"),
        "x-authorization": "Bearer " + localStorage.getItem("refreshToken"),
      },
      uploadLoading: null,
    };
  },
  props: {
    folderParentId: {
      type: Number,
      default: 0,
    },
  },
  created() {
    this.searchHistory =
      JSON.parse(localStorage.getItem("userReportSearchHistory")) || [];
  },
  methods: {
    showTips() {
      this.$message.warning("功能开发中...");
    },
    handleUploadBefore(file) {
      const fileType = file.name.substring(file.name.lastIndexOf("."));
      const isLimit = file.size / 1024 / 1024 < 10;

      if (fileType !== ".doc" && fileType !== ".docx") {
        this.$message.error("只能上传 doc|docx 格式的文档!");
        return false;
      }
      if (!isLimit) {
        this.$message.error("上传文件大小不能超过 10MB!");
        return false;
      }
      this.uploadLoading = Loading.service({ text: "导入中..." });
    },
    handleUploadSuccess(res, file) {
      this.$nextTick(() => {
        // 以服务的方式调用的 Loading 需要异步关闭
        this.uploadLoading.close();
      });

      if (res.code === 200) {
        this.$message.success("导入成功");
        this.$emit("refreshReportList");
      } else {
        this.$message.error(res.message);
      }
    },
    handleUploadError() {
      this.$nextTick(() => {
        // 以服务的方式调用的 Loading 需要异步关闭
        this.uploadLoading.close();
      });
      this.$message.error("服务器异常，请稍后再试");
    },
    handleHistorySearch(val) {
      this.searchKey = val;
      this.handleSearch();
    },
    handleSearch() {
      if (this.searchKey) {
        this.searchHistory = this.searchHistory.slice(0, 2);
        this.searchHistory.unshift(this.searchKey);
        localStorage.setItem(
          "userReportSearchHistory",
          JSON.stringify(this.searchHistory)
        );
        this.$router.push({
          path: "/console/list",
          query: { s: this.searchKey },
        });
      }
    },
    handleNewCommand(command) {
      if (command === "folder") {
        this.dialogFolderVisible = true;
      } else {
        this.$router.push(command);
      }
    },
    handleAddFolder() {
      this.$refs["folderForm"].validate((valid) => {
        if (valid) {
          this.folderLoading = true;

          axiosRequest(
            "/user-report/add-folder",
            { name: this.folderForm.folderName, parentId: this.folderParentId },
            axiosOptions("post", "", "json")
          )
            .then((res) => {
              if (res.data && res.data.code === 200 && res.data.data) {
                this.dialogFolderVisible = false;
                this.$message.success("添加成功");
                this.$emit("refreshFolderList");
              } else {
                this.$message.success("添加失败");
              }

              this.folderLoading = false;
            })
            .catch(() => {
              this.folderLoading = false;
              this.$message.success("服务器出错，请稍后再试");
            });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/var.scss";
@import "@/assets/css/compose.scss";
</style>
